import useAppContext from "./useAppContext";
import { useMemo } from "react";

/**
 * Hook checks whether the user has valid authorization from any of allowed roles
 *
 * @param {array<string>} allowedRoles
 * @returns {{authorized: boolean, authorizedRoles: array<string>}}
 */
function useAuthorization(allowedRoles) {
  const { data: appContext } = useAppContext();
  const rolesSet = useMemo(() => new Set(appContext.userProfiles), [appContext.userProfiles]);

  const authorizedRoles = allowedRoles.filter((role) => rolesSet.has(role));

  return {
    authorized: authorizedRoles.length > 0,
    authorizedRoles,
  };
}

export default useAuthorization;
